import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "./api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [org, setOrg] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("tm_token");
    if (!token) { setUser(null); setOrg(null); setLoading(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user); setOrg(data.organization);
    } catch {
      localStorage.removeItem("tm_token"); setUser(null); setOrg(null);
    } finally { setLoading(false); }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const signin = async (email, password) => {
    const { data } = await api.post("/auth/signin", { email, password });
    localStorage.setItem("tm_token", data.token);
    await refresh();
    return data.user;
  };

  const signup = async (email, password, full_name, referral_code = null) => {
    const { data } = await api.post("/auth/signup", { email, password, full_name, referral_code });
    localStorage.setItem("tm_token", data.token);
    await refresh();
    return data.user;
  };

  const signout = () => { localStorage.removeItem("tm_token"); setUser(null); setOrg(null); };

  return (
    <AuthContext.Provider value={{ user, org, loading, signin, signup, signout, refresh, setOrg }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() { return useContext(AuthContext); }
